<template lang="html">
<div class="reset-password">
  <row>
    <div class="sl-col-4">
      <div class="sl-pwd">
        <p>{{$t('Views.Password.title')}}</p>
        <input type="password" :placeholder="$t('Views.Password.old')" v-model="oPwd">
        <input type="password" :placeholder="$t('Views.Password.new')" v-model="nPwd1" :class="{'sl-error': error}">
        <input type="password" :placeholder="$t('Views.Password.rNew')" v-model="nPwd2" :class="{'sl-error': error}">
        <span v-show="error" class="sl-error-msg">* {{$t('Views.Password.err')}}</span>
        <el-button :class="{'sl-btn-disable':btnDisable}" @click="confirm" :disabled="btnDisable" :loading="btnLoading">{{$t('Views.Password.confirm')}}</el-button>
      </div>
    </div>
  </row>
</div>
</template>

<script>
import api from '../../api'
export default {
  name: 'reset-password',
  data() {
    return {
      oPwd: '',
      nPwd1: '',
      nPwd2: '',
      error: false,
      btnLoading: false
    }
  },
  watch: {
    nPwd1() {
      this.error = this.nPwd1 !== this.nPwd2 ? !0 : 0
    },
    nPwd2() {
      this.error = this.nPwd1 !== this.nPwd2 ? !0 : 0
    }
  },
  computed: {
    btnDisable() {
      return this.error || this.oPwd === '' || this.nPwd1 === '' || this.nPwd2 === ''
    }
  },
  methods: {
    errorMsg(res) {
      this.$notify.error({
        title: 'failed',
        message: res.data.msg
      })
    },
    successMsg(res) {
      this.$notify.success({
        title: 'success',
        message: res.data.msg
      })
    },
    confirm() {
      this.$ga.event('Button', 'Confirm', 'Modify password')
      const vm = this
      this.btnLoading = true
      api.UpdatePassword({
        old: this.oPwd,
        new: this.nPwd1
      }).then(res => {
        if (res.data.code !== 200) {
          vm.errorMsg(res)
        } else {
          vm.successMsg(res)
          vm.$router.push({
            name: 'Login'
          })
        }
        vm.btnLoading = false
      })
    }
  }
}
</script>
<style scoped>
.sl-pwd {
  background: #FFFFFF;
  box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.10);
  border-radius: 2px;
  width: 380px;
  text-align: center;
  margin: 20px auto 20px;
}

.sl-pwd p {
  font-family: Avenir-Book;
  font-size: 16px;
  color: #4A4A4A;
  line-height: 16px;
  padding-top: 30px;
}

.sl-pwd input {
  display: inline-block;
  background: #F7F7F7;
  border: 1px solid #D8D8D8;
  border-radius: 2px;
  width: 340px;
  margin-bottom: 20px;
  height: 40px;
  font-family: Avenir-Book;
  font-size: 14px;
  color: #9B9B9B;
  line-height: 40px;
  padding-left: 10px;
}

.sl-pwd button {
  background: #2B90E9;
  border-radius: 2px;
  width: 140px;
  height: 36px;
  border: 0;
  font-family: Avenir-Medium;
  font-size: 14px;
  color: #FFFFFF;
  margin-bottom: 34px;
}

.sl-pwd input.sl-error {
  border-color: red;
}

.sl-error-msg {
  display: inline-block;
  width: 380px;
  position: relative;
  top: -18px;
  color: red;
}

.reset-password .sl-btn-disable {
  background-color: #d7d7d7;
}
</style>



// WEBPACK FOOTER //
// passwords.vue?b374cdce